import {ResourceAllocationState, ProjectPhase} from '../../../types';

export const phaseHandlers = {
    ProjectPhaseAdded: (
        state: ResourceAllocationState,
        data: ProjectPhase
    ): ResourceAllocationState => {
        return {
            ...state,
            phases: {...state.phases, [data.id]: data}
        };
    },
    ProjectPhaseUpdated: (
        state: ResourceAllocationState,
        data: {id: string; updates: Partial<ProjectPhase>}
    ): ResourceAllocationState => {
        return {
            ...state,
            phases: {
                ...state.phases,
                [data.id]: {
                    ...state.phases[data.id],
                    ...data.updates
                }
            }
        };
    },
    ProjectPhaseDeleted: (
        state: ResourceAllocationState,
        data: {id: string}
    ): ResourceAllocationState => {
        const {[data.id]: _removed, ...rest} = state.phases;
        return {...state, phases: rest};
    }
};
